$(function() {
  OT.createNS('OT.Search');

  var $body = $('body');

  OT.Search.toggleMenu = function() {
    $('.see-filters').on('click', function(event) {
      event.preventDefault();
      $(this).parents('.menu-main').toggleClass('collapsed expanded');
    });
  }


  OT.Search.stylesheet = function() {
    $('.menu-section, .lb-wrap').height('');
    // README: logic handles cases where second timeslot is unavailble, and first timeslot is available, ensuring 3 timeslots displayed for smaller breakpoints.
    $('.timeslot-control').closest('.timeslot-option').addClass('timeslot-control');
    $('body li.timeslot-option:not(.timeslot-control):nth-child(2)').prev().css('display', 'block');
  }


  OT.Search.toggleLHN = function() {
    $('body.platform-mobile .toggle-filter-bar, body.platform-mobile .close-filters').on('click', function(e){
      e.preventDefault();
      $body.toggleClass('hide-lhn show-lhn');
      $('#filters-bar').css('top', $('#search_results_container')[0].getBoundingClientRect().top);
    });
    $('body.platform-mobile #map').on('click', function(){
      if ($body.hasClass('show-lhn')) {
        $body.toggleClass('hide-lhn show-lhn');
      }
    });
  }

  OT.Search.toggleMenu();
  OT.Search.stylesheet();
  OT.Search.toggleLHN();
});
